import {
  SearchSuggestion,
  useKeyNavigation,
} from '@silvertours/front-entities';
import { useRef, FocusEvent, RefObject, useEffect } from 'react';
import { Theme } from '@silvertours/front-shared';
import { useTranslations } from 'next-intl';
import {
  StyledButton,
  SuggestionWrapper,
  ErrorMessage,
} from './SelectStation.styles';
import { StationItem } from './StationItem';
import { useSearchContext } from '../../SearchFormLegacy/context';

type Props = {
  connectedInputContainer?: RefObject<HTMLInputElement>;
  onLastElementBlur: (event: FocusEvent<HTMLElement, Element>) => void;
  loading: boolean;
  onItemClick: (suggestion?: SearchSuggestion) => void;
  results: Array<SearchSuggestion> | null;
};

const Suggestion = ({
  connectedInputContainer,
  onLastElementBlur,
  loading,
  onItemClick,
  results,
}: Props) => {
  const { state } = useSearchContext();
  const listRef = useRef<HTMLUListElement>(null);
  const t = useTranslations('features.stageLegacy.stage.searchForm');
  const isMobileTouchDevice = Theme.useIsMobileTouchDevice();

  useEffect(() => {
    if (isMobileTouchDevice && connectedInputContainer?.current) {
      connectedInputContainer.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isMobileTouchDevice, connectedInputContainer]);
  const handleEnter = (item?: SearchSuggestion) => {
    onItemClick(item);
  };

  const { focusedItem, onMouseEnter, onMouseLeave } =
    useKeyNavigation<SearchSuggestion>(results || [], listRef, handleEnter);

  if (!loading && !results?.length && !state?.depLocation) {
    return <ErrorMessage>{t('errorTexts.dep')}</ErrorMessage>;
  }

  return (
    results && (
      <SuggestionWrapper ref={listRef} id="locationSuggest">
        {results.map((suggestion: SearchSuggestion, index) => (
          <li key={suggestion.objectID}>
            <StyledButton
              type="button"
              tabIndex={0}
              onBlur={onLastElementBlur}
              onMouseDown={() => onItemClick(suggestion)}
              onMouseEnter={() => onMouseEnter(index)}
              onMouseLeave={onMouseLeave}
              id={`locationSuggestItem-${index + 1}`}
              aria-selected={index === focusedItem}
            >
              <StationItem suggestion={suggestion} />
            </StyledButton>
          </li>
        ))}
      </SuggestionWrapper>
    )
  );
};

export { Suggestion };
